module.exports = __webpack_public_path__ + "img/bg.c8c83b18.png";